import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BookClub } from '../../models/bookclub';
import { ConfigService } from '../../services/config.service';
import { ApiService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { CustomerType } from 'src/app/models/client-configuration';
import { LocaleService } from 'src/app/services/locale.service';
import { RecordSwipperItem, RecordSwipperUtils } from 'src/app/models/record-swiper';

@Component({
  selector: 'app-slider-book-clubs',
  templateUrl: './slider-book-clubs.component.html',
  styleUrls: ['../slider/slider.component.scss', './slider-book-clubs.component.scss'],
})
export class SliderBookClubsComponent {
  @Input()
  items: BookClub[];

  @Input()
  title: string;

  @Output()
  selected: EventEmitter<BookClub> = new EventEmitter();

  swiperItems: RecordSwipperItem[] = [];
  fadeAnimation: string;
  customerType: CustomerType;
  titleI18N: string;
  textDirection: string;
  selectedItemIndex: number;

  constructor(
    private configService: ConfigService,
    private apiService: ApiService,
    private authService: AuthService,
    private localeService: LocaleService
  ) {}

  ngOnInit() {
    this.textDirection = this.localeService.getTextDirection();
    this.customerType = this.configService.customerType;
    this.titleI18N = 'bookClubs.carousel.' + this.title;
    this.buildSwiperItems();
  }

  private buildSwiperItems() {
    this.swiperItems = [];
    this.items.forEach((oleItem) => this.swiperItems.push(RecordSwipperUtils.fromOleItemToSwiperItem(oleItem)));
  }

  onSelected(clickedItemIndex: number, item: RecordSwipperItem) {
    const userId = this.authService.isAuthenticated() ? this.authService.getLoggedUser().id : null;

    const params = {
      clubId: item.id,
      patronId: userId,
    };

    if (this.selectedItemIndex === clickedItemIndex) {
      this.onCloseInfo();
      return;
    }

    this.apiService.getLinkToBookclub(params).subscribe((url) => {
      if (!url.includes('clubId')) {
        url = url + '&clubId=' + params['clubId'];
      }
      window.open(url, '_blank', 'noopener');
    });
  }

  onCloseInfo() {
    this.selectedItemIndex = null;
  }
}
